// Poslední vybraný bod meteogramu ALADIN — localStorage.
// getLastMeteogramPoint/setLastMeteogramPoint: naposledy vybraný bod, pro auto-výběr při návratu
//   na stránku (MeteogramLayout).
// getLastMeteogramPoints: posledních MAX bodů, pro zobrazení pod ikonou v hlavním menu
//   (stejný vzor jako useLastStations.js).
const KEY = 'cw_last_meteogram_points'
const MAX = 4

export function getLastMeteogramPoints() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

export function getLastMeteogramPoint() {
  return getLastMeteogramPoints()[0] || null
}

export function addLastMeteogramPoint(point) {
  const list = getLastMeteogramPoints().filter(p => p.id !== point.id)
  list.unshift({ id: point.id, category: point.category, name: point.name, extra: point.extra })
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)))
}
